import { Button, CellContentPosition, Icon, Skeleton, Stack, Table, TableCell, TableColumnData, TableRow } from "@tm/components"
import { useLocalization } from "@tm/localization"
import { CustomArticleListResponse } from "@tm/data/basket"
import { useMemo } from "react"
import { EmptyCompilation } from "@bundles/compilations/components/EmptyCompilation"
import { CompilationRow } from "./CompilationRow"
import { useOwnArticlesStore } from "../store"
import { useCompilations } from "../useCompilations"

export function CompilationTable() {
    const { setSelectedCompilation, setIsExpandedCompilationsList, setCompilationIdsToDelete, setCompilationToEdit } = useOwnArticlesStore()
    const { translateText } = useLocalization()

    const { compilations, hasUnlistedItems, compilationsLoading } = useCompilations()

    function handleClickDelete(compilation: CustomArticleListResponse) {
        setCompilationIdsToDelete([compilation.id])
    }

    function handleClickDetails(compilation: CustomArticleListResponse | null) {
        setSelectedCompilation(compilation)
        setIsExpandedCompilationsList(false)
    }

    function handleClickEdit(compilation: CustomArticleListResponse) {
        setCompilationToEdit({ type: "edit", ...compilation })
    }

    const columns = useMemo<TableColumnData[]>(
        () => [{ header: translateText(155) }, { header: translateText(617) }, { header: translateText(258) }, { header: translateText(1252) }, {}],
        []
    )

    return (
        <Stack gap={0.5} height="100%" pt={1}>
            {compilationsLoading && (
                <>
                    <Skeleton variant="rounded" width="100%" height="32px" />
                    <Skeleton variant="rounded" width="100%" height="32px" />
                    <Skeleton variant="rounded" width="100%" height="32px" />
                </>
            )}
            {!compilationsLoading && compilations?.length === 0 && !hasUnlistedItems && <EmptyCompilation />}
            {(!!compilations?.length || hasUnlistedItems) && (
                <Table columns={columns} headerBackground="inherit" scrollbar="system" headerStyle="default" overflowY="auto">
                    {hasUnlistedItems && (
                        <TableRow colCount={5} onClick={() => handleClickDetails(null)} sx={{ cursor: "pointer" }} rowCap={4}>
                            <TableCell sx={{ gridColumnStart: 1, gridColumnEnd: "span 4" }}>{translateText(14077)}</TableCell>
                            <TableCell alignContent={CellContentPosition.right} sx={{ py: "3px" }}>
                                <Button onClick={() => handleClickDetails(null)} endIcon={<Icon name="details" />} variant="contained">
                                    {translateText(43)}
                                </Button>
                            </TableCell>
                        </TableRow>
                    )}
                    {compilations?.map((compilation) => (
                        <CompilationRow
                            key={compilation.id}
                            compilation={compilation}
                            onClickDelete={handleClickDelete}
                            onClickDetails={handleClickDetails}
                            onClickEdit={handleClickEdit}
                        />
                    ))}
                </Table>
            )}
        </Stack>
    )
}
